import classNames from 'classnames';
import { type Link, type LinkProps } from 'react-router-dom';

import styles from './Button.module.scss';

type Size = 's' | 'm' | 'l';
type Color = 'primary' | 'danger' | 'outline' | 'link';
type Tag = 'button' | typeof Link;

interface ButtonProps {
  size?: Size;
  color?: Color;
  children?: React.ReactNode;
  tag?: Tag;
  className?: string;
}

type Props = ButtonProps &
  (
    | (React.ButtonHTMLAttributes<HTMLButtonElement> & { to?: never })
    | (LinkProps & { type?: never })
  );

const Button: React.FC<Props> = ({
  size = 'm',
  color = 'primary',
  children,
  type = 'button',
  tag = 'button',
  className,
  ...props
}) => {
  const Element = tag as React.ElementType;

  return (
    <Element
      className={classNames(
        styles.button,
        {
          [styles.sizeS]: size === 's',
          [styles.sizeM]: size === 'm',
          [styles.sizeL]: size === 'l',
        },

        {
          [styles.colorPrimary]: color === 'primary',
          [styles.colorDanger]: color === 'danger',
          [styles.colorOutline]: color === 'outline',
          [styles.colorLink]: color === 'link',
        },
        className,
      )}
      type={tag === 'button' ? type : undefined}
      {...props}
    >
      {children}
    </Element>
  );
};

export default Button;
